import { Directive, ElementRef, inject, input } from '@angular/core';

@Directive({
  selector: '[appTodoEntriesWrapper]',
  standalone: true,
})
export class TodoEntryWrapperDirective {
  // Inputs
  date = input.required<Date>();

  // DI
  readonly elementRef = inject(ElementRef);
}
